import DialogTitle from '@mui/material/DialogTitle';
import { Typography } from '@mui/material';
import { X } from '../../../../icons/x';
import { DialogStyle } from './style';

type AccountLinkedinDialogHeaderProps = {
  onCloseClick: () => void,
  title: string,
}
  
export default function AccountLinkedinDialogHeader({
  onCloseClick,
  title,
}:AccountLinkedinDialogHeaderProps): JSX.Element {
  return (
    <DialogTitle
      style={ DialogStyle.dialogTitle.style }
      sx={ DialogStyle.dialogTitle.sx }
    >
      <Typography>{ title }</Typography>
      <X
        style={ DialogStyle.close }
        onClick={ onCloseClick }
      />
    </DialogTitle>
  );
}
